import { ManuscriptInterface } from "@/model/views/Manuscript";
import { OrderPrice } from "@/model/price";
import { MANUSCRIPT_DELIVERY_ADDRESS } from "@/model/delivery";
import { mapDeliveryMethod } from "@/gateway/request/utils";
import { optionCardCaseShow } from "@/model/views/display";

const mapOrderList: Function = (f: ManuscriptInterface): object => {
  return f.orderDetailsList.map(order => {
    return {
      numberOfPrints: order.numberOfPrints,
      logoFile1: order.logoFile1,
      logoFile2: order.logoFile2,
      request: order.message
    };
  });
};

const mapOptions: Function = (f: ManuscriptInterface): object => {
  const isBusinessCardCaseShow = optionCardCaseShow(f.orderDetailsList);
  return {
    optionCardCase: isBusinessCardCaseShow
      ? f.availabilityOfOptions.businessCardCase
      : "",
    optionRoundShape: f.availabilityOfOptions.roundShapeProcessing,
    optionTrace: f.availabilityOfOptions.logoTrace
  };
};

const mapDeliveryTo: Function = (f: ManuscriptInterface): object => {
  switch (true) {
    case f.productDeliveryAddress.deliveryAddress ===
      MANUSCRIPT_DELIVERY_ADDRESS.OTHER_ADDRESS:
      return {
        deliveryTo: f.productDeliveryAddress.deliveryAddress,
        deliveryName: f.productDeliveryAddress.name,
        deliveryKana: "",
        deliveryCompany: f.productDeliveryAddress.company,
        deliveryZipcode: f.productDeliveryAddress.zipcode,
        deliveryAddress: f.productDeliveryAddress.address,
        deliveryTel: f.productDeliveryAddress.tel,
        deliveryEmail: ""
      };
    case f.productDeliveryAddress.deliveryAddress ===
      MANUSCRIPT_DELIVERY_ADDRESS.AT_THE_STORE:
      return {
        deliveryTo: f.productDeliveryAddress.deliveryAddress,
        deliveryName: "",
        deliveryKana: "",
        deliveryCompany: "",
        deliveryZipcode: "",
        deliveryAddress: "",
        deliveryTel: "",
        deliveryEmail: ""
      };
    default:
      throw new Error("Unexpected route was called.");
  }
};

const map: Function = (f: ManuscriptInterface, o: OrderPrice): object => {
  return Object.assign(
    {
      type: f.printType.text + f.printType.type,
      paperName: f.paper.name,
      paperThickness: f.paper.thickness,
      confirmationMethod: f.confirmationOfTheFinishedImage.confirmationMethod,
      confirmationMethodFax:
        f.confirmationOfTheFinishedImage.confirmationMethod === "FAXで確認する"
          ? f.confirmationOfTheFinishedImage.fax
          : "",
      customerName: f.orderInformation.name,
      customerKana: f.orderInformation.kana,
      customerZipcode: f.orderInformation.zipcode,
      customerAddress: f.orderInformation.address,
      customerCompany: f.orderInformation.company,
      customerTel: f.orderInformation.tel,
      customerEmail: f.orderInformation.email,
      paymentMethod: f.paymentMethod.method,
      question: f.questions.question,

      // 金額
      ...o,

      zeusToken: f.submitBtn.token,
      zeusCardName: f.submitBtn.cardName
    },
    {
      orderList: mapOrderList(f)
    },
    mapDeliveryTo(f),
    mapOptions(f),
    mapDeliveryMethod(
      f.productDeliveryAddress.deliveryAddress,
      f.productDeliveryMethod
    )
  );
};

export default {
  map
};
